import { LANG_CODES, LANGS } from '../../lib/languages';

/** "Teaching ___ to students who speak ___" — the two languages a class runs on. */
export default function LanguagePicker({ language, nativeLanguage, onChange }: {
  language: string;
  nativeLanguage: string;
  onChange: (language: string, nativeLanguage: string) => void;
}) {
  return (
    <div className="grid-2">
      <div className="field">
        <label htmlFor="lang-teach">Language you teach</label>
        <select id="lang-teach" value={language} onChange={e => onChange(e.target.value, nativeLanguage)}>
          {LANG_CODES.map(c => <option key={c} value={c}>{LANGS[c].name} · {LANGS[c].native}</option>)}
        </select>
      </div>
      <div className="field">
        <label htmlFor="lang-native">Your students' language</label>
        <select id="lang-native" value={nativeLanguage} onChange={e => onChange(language, e.target.value)}>
          {LANG_CODES.map(c => <option key={c} value={c}>{LANGS[c].name} · {LANGS[c].native}</option>)}
        </select>
        <span className="hint">Translations are written in this language.</span>
      </div>
    </div>
  );
}
